import {EntityField} from "../../core/genericdocuments/EntityField"
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {Notification} from "../../models/Notification"

export const notificationFields: IntercateKeysMap<Notification, EntityField<Notification>> = {
    id: {
		name: "id", dataType: EntityFieldDataType._string, label: "Id obaveštenja",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    title: {
		name: "title", dataType: EntityFieldDataType._string, label: "Ime",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    description: {
		name: "description", dataType: EntityFieldDataType._string, label: "Opis",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    seen: {
		name: "seen", dataType: EntityFieldDataType._boolean, label: "Pregledano",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    action: {
		name: "action", dataType: EntityFieldDataType._string, label: "Akcija",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    userId: {
		name: "userId", dataType: EntityFieldDataType._reference, label: "Korisnik",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Users
		},
		validator: { required: false },
		sortable: true
	},
    data: {
		name: "data", dataType: EntityFieldDataType._string, label: "Dodatni podaci",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    createdAt: {
		name: "createdAt", dataType: EntityFieldDataType._date, label: "Datum kreiranja",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
}

const notificationFieldsArray: Array<EntityField<Notification>> = [
	notificationFields.title,
    notificationFields.description,
    notificationFields.userId,
	
]

export const notificationFieldsDescriptor: EntityFieldsDescriptor<Notification> = {
	listFields: notificationFieldsArray,
	createFormFields: notificationFieldsArray,
	updateFormFields: notificationFieldsArray
}